module.exports = __webpack_public_path__ + "static/media/I_ss_ui.9c5c29bf.png";